// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3KwD_";
export { _1 as "__esModule", _2 as "mobile", _3 as "container" }
export default { "__esModule": _1, "mobile": _2, "container": _3 }
